import { Locale } from '@yarmill/types';

export function getAdjustedLocale(locale: Locale) {
  if (locale === 'cs' || locale === 'sk') {
    return 'cs';
  }

  return 'en';
}
